import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';

export enum MyWorkCategory {
  ENTRIES = 'entries',
  WORKSHEETS = 'worksheets',
  TASKS = 'tasks',
  TEMPLATES = 'templates',
}

export type ReviewSummaryStateKey =
  | 'inProgress'
  | 'rejected'
  | 'needsReview'
  | 'sentForReview'
  | 'accepted'
  | 'retracted';

export type TasksReviewSummaryCountKey =
  | 'cancelled'
  | 'completed'
  | 'failed'
  | 'invalid'
  | 'inProgress'
  | 'pending'
  | 'skipped';

export const REVIEW_ITEM_STATUS_LABELS = [
  'in progress',
  'needs revision',
  'ready for review',
  'sent for review',
  'completed',
] as const;

export type ReviewItemStatusLabel = (typeof REVIEW_ITEM_STATUS_LABELS)[number];

export const DEFAULT_REVIEW_STATUS_LABEL: ReviewItemStatusLabel = 'in progress';

export const WORKSHEET_REVIEW_ITEM_STATUS_LABELS = REVIEW_ITEM_STATUS_LABELS.filter(
  (statusLabel) => statusLabel !== 'in progress'
);

export const TASK_STATUS_LABELS = [
  'pending',
  'in progress',
  'failed',
  'cancelled',
  'invalid',
  'completed',
  'skipped',
] as const;

export type TaskStatusLabel = (typeof TASK_STATUS_LABELS)[number];

export const DEFAULT_TASK_STATUS_LABEL: TaskStatusLabel = 'pending';

export const REVIEW_STATUS_LABEL_TO_SUMMARY_KEY: Record<ReviewItemStatusLabel, ReviewSummaryStateKey> = {
  'in progress': 'inProgress',
  'needs revision': 'rejected',
  'ready for review': 'needsReview',
  'sent for review': 'sentForReview',
  completed: 'accepted',
};

export const TASK_STATUS_LABEL_TO_SUMMARY_KEY: Record<TaskStatusLabel, TasksReviewSummaryCountKey> = {
  cancelled: 'cancelled',
  completed: 'completed',
  failed: 'failed',
  invalid: 'invalid',
  'in progress': 'inProgress',
  pending: 'pending',
  skipped: 'skipped',
};

export const TASK_STATUS_TYPE_TO_SUMMARY_KEY: Record<ProcessTaskStatusType, TasksReviewSummaryCountKey> = {
  [ProcessTaskStatusType.CANCELLED]: 'cancelled',
  [ProcessTaskStatusType.COMPLETED]: 'completed',
  [ProcessTaskStatusType.FAILED]: 'failed',
  [ProcessTaskStatusType.INVALID]: 'invalid',
  [ProcessTaskStatusType.IN_PROGRESS]: 'inProgress',
  [ProcessTaskStatusType.PENDING]: 'pending',
  [ProcessTaskStatusType.SKIPPED]: 'skipped',
};

export const TASKS_REVIEW_SUMMARY_COUNT_KEYS: Array<TasksReviewSummaryCountKey> = [
  'cancelled',
  'completed',
  'failed',
  'invalid',
  'inProgress',
  'pending',
  'skipped',
];
